import { render } from "./Colaborador.vue?vue&type=template&id=0bc78b74&scoped=true"
import script from "./Colaborador.vue?vue&type=script&lang=js"
export * from "./Colaborador.vue?vue&type=script&lang=js"

import "./Colaborador.vue?vue&type=style&index=0&id=0bc78b74&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc78b74"]])

export default __exports__